import { Communications } from './../../models/Communications';
import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Constants } from '../../utils/constants';
import { User } from 'src/app/models/User';
import { Partner } from 'src/app/models/Partner';
import { BehaviorSubject, Observable } from 'rxjs';
import { Task } from 'src/app/models/Task';
import { FilterSession } from 'src/app/models/FilterSession';
import { AppConfigServiceService } from '../app-config-service.service';
import { CustomerInfo } from 'src/app/models/CustomerInfo';
import { HelpdeskParameters } from 'src/app/models/HelpdeskParameters';
import { HelpersService } from '../shared/helpers.service';

@Injectable({
  providedIn: 'root'
})
export class HelpdeskService {

  public dataRowSource = new BehaviorSubject<Task>(JSON.parse(sessionStorage.getItem('helpdeskSelectedRow')));
  public currentDataRow = this.dataRowSource.asObservable();

  public paginatorPageSizeSource = new BehaviorSubject<string>(JSON.parse(localStorage.getItem('paginatorPageSize')));
  public currentpaginatorPageSize = this.paginatorPageSizeSource.asObservable();

  public filterSessionSource = new BehaviorSubject<FilterSession>(JSON.parse(localStorage.getItem('filterSession')));
  public currentFilterSession = this.filterSessionSource.asObservable();

  public refreshPeriodSource = new BehaviorSubject<string>(JSON.parse(localStorage.getItem('refreshPeriod')));
  public currentRefreshPeriod = this.refreshPeriodSource.asObservable();

  public periodTabSource = new BehaviorSubject<string>(JSON.parse(localStorage.getItem('periodTab')));
  public currentPeriodTab = this.periodTabSource.asObservable();

  //changeHelpdeskFilterToggle
  public helpdeskFilterToggleSource = new BehaviorSubject<string>(JSON.parse(localStorage.getItem('helpdeskFilterToggle')));
  public currentHelpdeskFilterToggle = this.helpdeskFilterToggleSource.asObservable();

  public helpdeskParametersSource = new BehaviorSubject<HelpdeskParameters>(JSON.parse(localStorage.getItem('helpdeskParameters')));
  public currentHelpdeskParameters = this.helpdeskParametersSource.asObservable();

  public helpdeskQuickRefresher = new EventEmitter<string>();

  private urediHelpdeskFilterSource = new BehaviorSubject<boolean>(false);
  public urediHelpdeskFilterBool = this.urediHelpdeskFilterSource.asObservable();

  public curHostname;
  constructor(private http: HttpClient, private MY_CONSTANTS: Constants,
    private appConfigService: AppConfigServiceService, private helpdeskService: HelpersService) {
      this.helpdeskService.currentHostname.subscribe( data => {
        this.curHostname = data;
      });
   }

  changeDataRow(row: Task) {
    sessionStorage.setItem('helpdeskSelectedRow', JSON.stringify(row));
    this.dataRowSource.next(row);
  }

  changeFilterSession(filterSession: FilterSession) {
    localStorage.setItem('filterSession', JSON.stringify(filterSession));
    this.filterSessionSource.next(filterSession);
  }

  changePaginatorPageSize(pageSize: string) {
    localStorage.setItem('paginatorPageSize', JSON.stringify(pageSize));
    this.paginatorPageSizeSource.next(pageSize);
  }

  changeRefreshPeriod(refreshPeriod: string) {
    localStorage.setItem('refreshPeriod', JSON.stringify(refreshPeriod));
    this.refreshPeriodSource.next(refreshPeriod);
  }

  changePeriodTab(periodTab: string) {
    localStorage.setItem('periodTab', JSON.stringify(periodTab));
    this.periodTabSource.next(periodTab);
  }
  changeHelpdeskFilterToggle(toggle: string) {
    localStorage.setItem('helpdeskFilterToggle', JSON.stringify(toggle));
    this.helpdeskFilterToggleSource.next(toggle);
  }

  changeHelpdeskParameters(newParameters: HelpdeskParameters) {
    localStorage.setItem('helpdeskParameters', JSON.stringify(newParameters));
    this.helpdeskParametersSource.next(newParameters);
  }

  changeUrediHelpdeskFilterBool(newBool: boolean) {
    this.urediHelpdeskFilterSource.next(newBool);
  }
  setTask(sessionUserPartner: string, userPartner: Partner, userWorker: User, text: string, id, nextContact, communicationIdChat) {
    let params = new HttpParams();
    if (sessionUserPartner) {
      params = params.append('sessionUser', sessionUserPartner);
      params = params.append('contactId', userPartner.contactId.toString());
    }
    params = params.append('text', text);

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
      params = params.append('contactId', userWorker.contactId.toString());
    }
    if (id) {
      params = params.append('id', id);
    }
    if (nextContact) {
      params = params.append('nextContact', nextContact);
    }
    params = params.append('duration', '0');
    params = params.append('communicationTypeId', communicationIdChat);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/setTask', params);
  }

  setContact(sessionUserPartner: string, id, contactId){
    let params = new HttpParams();

    if (sessionUserPartner) {
      params = params.append('sessionUser', sessionUserPartner);
    }
    if (id) {
      params = params.append('id', id);
    }
    if (contactId) {
    params = params.append('contactId', contactId);
    }
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/setContact', params);
  }

  //Pošljem ko spreminjam delavca (dialog na pregled-helpdesk in uredi-task). Pošlje tudi status 13, da ga nastavi!
  setTaskWorker(userPartner: Partner, text: string, id, nextContact, workerIdCurrent, communicationIdChat) {
    let params = new HttpParams();
    if (userPartner) {
      params = params.append('sessionUser', userPartner.sessionUser);
    }
    params = params.append('text', text);

    if (id) {
      params = params.append('id', id);
    }
    if (nextContact) {
      params = params.append('nextContact', nextContact);
    }
    params = params.append('workerIdCurrent', workerIdCurrent);
    params = params.append('duration', '0');
    params = params.append('status', '13');
    params = params.append('communicationTypeId', communicationIdChat);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/setTask', params);
  }

  setTaskDate(sessionUserPartner: string, userPartner: Partner, userWorker: User, text: string, id, nextContact, contactId, communicationIdChat) {
    let params = new HttpParams();
    if (sessionUserPartner) {
      params = params.append('sessionUser', sessionUserPartner);
    }

    if(text) {
      params = params.append('text', text);
    }

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }

    if(contactId) {
      params = params.append('contactId', contactId);
    }

    if (id) {
      params = params.append('id', id);
    }
    if (nextContact) {
      params = params.append('nextContact', nextContact);
    }
    params = params.append('duration', '0');
    params = params.append('communicationTypeId', communicationIdChat);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/setTask', params);
  }

  setTaskUpdate(sessionUserPartner: string, userPartner: Partner, userWorker: User, text: string, id,
     nextContact, duration, contactId, status, todoCode, communicationIdChat) {
    let params = new HttpParams();

    params = params.append('text', text);

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
      // params = params.append('workerIdCurrent', userWorker.workerId.toString());
    }
    if (id) {
      params = params.append('id', id);
    }
    if (nextContact) {
      params = params.append('nextContact', nextContact);
    }
    if (duration) {
      params = params.append('duration', duration);
    }
    params = params.append('status', status);
    params = params.append('contactId', contactId);
    params = params.append('communicationTypeId', communicationIdChat);
    params = params.append('todoCode', todoCode);
    params = params.append('workerId', userWorker.workerId.toString());
    return this.http.post(this.curHostname + this.appConfigService.api + 'helpdesk/setTask', params);
  }


  setTaskStatus(userWorker: User, text: string, id, status, contactId, communicationIdChat) {
    let params = new HttpParams();

    params = params.append('text', text);

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    if (id) {
      params = params.append('id', id);
    }
    if (status) {
      params = params.append('status', status)  ;
    }

    params = params.append('contactId', contactId);
    params = params.append('communicationTypeId', communicationIdChat);
    params = params.append('workerId', userWorker.workerId.toString());
    return this.http.post(this.curHostname + this.appConfigService.api + 'helpdesk/setTask', params);
  }

  getHelpDesk(sessionUserPartner: string, userWorker: User, userPartner: Partner, showNextContactCurrent, showUnknownAnswer, showUnreadTasks) {
    let params = new HttpParams();
    if (userWorker == null) {
      params = params.append('sessionUser', sessionUserPartner);
      params = params.append('partnerId', userPartner.id.toString());
    } else {
      params = params.append('sessionUser', userWorker.sessionUser);
      params = params.append('workerId', userWorker.workerId.toString());
    }
    if (showNextContactCurrent) {
      params = params.append('showNextContactCurrent', showNextContactCurrent);
    }
    if (showUnknownAnswer) {
      params = params.append('showUnknownAnswer', showUnknownAnswer);
    }
    if (showUnreadTasks) {
      params = params.append('showUnread', showUnreadTasks);
    }
    
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdesk', params);
  }

  getOneHelpdeskRow(sessionUserPartner: string, userWorker: User, userPartner: Partner, id) {
    let params = new HttpParams();
    if (userPartner) {
      params = params.append('sessionUser', sessionUserPartner);
      params = params.append('partnerId', userPartner.id.toString());
    } else {
      params = params.append('sessionUser', userWorker.sessionUser);
      params = params.append('workerId', userWorker.workerId.toString());
    }
    params = params.append('id', id);
    
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdesk', params);
  }

  getHelpDeskFiles(sessionUserPartner: string, userWorker: User, userPartner: Partner, idTask) {
    let params = new HttpParams();
    if (userWorker == null || userWorker == undefined) {
      params = params.append('sessionUser', sessionUserPartner);
      params = params.append('partnerId', userPartner.id.toString());
    }
    if (userPartner == null || userPartner == undefined) {
      params = params.append('sessionUser', userWorker.sessionUser);
      params = params.append('workerId', userWorker.workerId.toString());
    }
    params = params.append('id', idTask);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdesk', params);
  }

  /*getHelpDeskByFilterStatus(sessionUserPartner: string, userWorker: User, userPartner: Partner, status) {
    let params = new HttpParams();
    if (userWorker == null || userWorker == undefined) {
      params = params.append('sessionUser', sessionUserPartner);
      params = params.append('partnerId', userPartner.id.toString());
    } else {
      params = params.append('sessionUser', userWorker.sessionUser);
      params = params.append('workerId', userWorker.workerId.toString());
    }
    params = params.append('status', status);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdesk', params);
  }*/

  getHelpDeskByFilterAll(sessionUserPartner: string, userWorker: User, userPartner: Partner, statuses: Array<string>,
     dateFrom, dateTo, search, showNextContactCurrent, showNextContactTomorrow, showUnknownAnswer, cooperations, workers, showUnread ) {
    let params = new HttpParams();
    if (userWorker == null || userWorker == undefined) {
      params = params.append('sessionUser', sessionUserPartner);
      params = params.append('partnerId', userPartner.id.toString());
    } else {
      params = params.append('sessionUser', userWorker.sessionUser);
      params = params.append('workerId', userWorker.workerId.toString());
    }
    if (dateFrom) {
      params = params.append('dateFrom', dateFrom);
    }
    if (dateTo) {
      params = params.append('dateTo', dateTo);
    }
    if (statuses) {
      params = params.append('statuses', JSON.stringify(statuses));
    }
    if (search) {
      params = params.append('search', search);
    }
    if (showNextContactCurrent) {
      params = params.append('showNextContactCurrent', showNextContactCurrent);
    }
    if (showNextContactTomorrow) {
      params = params.append('showNextContactTomorrow', showNextContactTomorrow);
    }
    if (showUnknownAnswer) {
      params = params.append('showUnknownAnswer', showUnknownAnswer);
    }
    if (cooperations) {
      params = params.append('cooperations', JSON.stringify(cooperations));
    }
    if (workers) {
      workers = workers.map((worker) => parseInt(worker));
      params = params.append('workers', JSON.stringify(workers));
    }
    if (showUnread) {
      params = params.append('showUnread', showUnread);
    }
    console.log(params);
    
    let a = this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdesk', params);
    
    return a;
  }

  getHelpDeskByFilterDate(sessionUserPartner: string, userWorker: User, userPartner: Partner, dateFrom, dateTo, search) {
    let params = new HttpParams();
    if (userWorker == null || userWorker == undefined) {
      params = params.append('sessionUser', sessionUserPartner);
      params = params.append('partnerId', userPartner.id.toString());
    } else {
      params = params.append('sessionUser', userWorker.sessionUser);
      params = params.append('workerId', userWorker.workerId.toString());
    }
    if (dateFrom) {
      params = params.append('dateFrom', dateFrom);
    }
    if (dateTo) {
      params = params.append('dateTo', dateTo);
    }
    if (search) {
      params = params.append('search', search);
    }
    if (!dateTo && !dateFrom){
    } else {
      return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdesk', params);
    }
  }


  getHelpdeskTaskById(sessionUserPartner: string, userWorker: User, userPartner: Partner, id) {
    let params = new HttpParams();
    if (userWorker == null || userWorker == undefined) {
      params = params.append('sessionUser', sessionUserPartner);
      params = params.append('partnerId', userPartner.id.toString());
    }
    if (userPartner == null || userPartner == undefined) {
      params = params.append('sessionUser', userWorker.sessionUser);
      params = params.append('workerId', userWorker.workerId.toString());
    }
    params = params.append('id', id);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdesk', params);
  }

  getHelpDeskMailContent(sessionUserPartner, userWorker: User, id) {
    let params = new HttpParams();

    if (userWorker != null) {
      params = params.append('sessionUser', userWorker.sessionUser);
    } else {
      params = params.append('sessionUser', sessionUserPartner);
    }

    params = params.append('id', id);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdeskMailContent', params);
  }

  setFileToTask(sessionUserPartner: string, userWorker: User, id, type, code, fileId, fileName, filePath, fileType, sizeOnDisk) {
    let params = new HttpParams();

    if (userWorker != null) {
      params = params.append('sessionUser', userWorker.sessionUser);
    } else {
      params = params.append('sessionUser', sessionUserPartner);
    }
    params = params.append('id', id);
    params = params.append('type', type);
    params = params.append('code', code);
    if (fileId) {
      params = params.append('fileId', fileId);
    }
    params = params.append('fileName', fileName);
    params = params.append('filePath', filePath);
    if (fileType) {
      params = params.append('fileType', fileType);
    }
    if (sizeOnDisk) {
      params = params.append('sizeOnDisk', sizeOnDisk);
    }
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/setFileToTask', params);
  }


 /* //koda za nodejs
 postFile(file: File): any {
    let formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post<any>('http://localhost:3000/', formData);
  }*/

  postFile(file: File): any {
    let formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(this.curHostname + this.appConfigService.apiFileUpload + 'fileUpload/upload', formData);
  }

  deleteFile(path: string): any {
    let params = new HttpParams();
    params = params.append('path', path);
    return this.http.delete<any>(this.curHostname + this.appConfigService.apiFileUpload + 'fileUpload/delete-file', {params: params});
  }

  downloadFile(path: string): any {
    let params = new HttpParams();
    params = params.append('path', path);
    const requestOptions: Object = {
      /* other options here */
      responseType: 'blob',
      params: params
    }
    return this.http.get<any>(this.curHostname + this.appConfigService.apiFileUpload + 'fileUpload/download', requestOptions); //'http://localhost:8080/fileUpload/download'
  }

  getMessages(sessionPartner, userWorker: User, userPartner: Partner, id) {
    let params = new HttpParams();
    params = params.append('id', id); // Dobi se iz /getHelpdesk, polje id.

    if (userWorker != null) {
      params = params.append('sessionUser', userWorker.sessionUser);
      params = params.append('workerId', userWorker.workerId.toString());
    } else {
      params = params.append('partnerId', userPartner.id.toString());
      params = params.append('sessionUser', sessionPartner);
    }
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/messages', params);
  }

  setMessages(sessionUserPartner, id, messageId, text, userPartner: Partner, userWorker: User) {
    let params = new HttpParams();

    params = params.append('id', id);

    if (messageId) {
      params = params.append('messageId', messageId);
    }

    params = params.append('text', text);

    if (userWorker != null) {
      params = params.append('sessionUser', userWorker.sessionUser);
      params = params.append('workerId', userWorker.workerId.toString());
    } else {
      params = params.append('partnerId', userPartner.id.toString());
      params = params.append('sessionUser', sessionUserPartner);
    }

    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/setMessage', params);
  }

  setCurrentWorker(userWorker: User, id) {
    let params = new HttpParams();
    params = params.append('sessionUser', userWorker.sessionUser);
    params = params.append('type', 'SET');
    params = params.append('id', id);

    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/setCurrentWorker', params);
  }

  deleteCurrentWorker(userWorker: User, id) {
    let params = new HttpParams();
    params = params.append('sessionUser', userWorker.sessionUser);
    params = params.append('type', 'CLEAR');
    params = params.append('id', id);

    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/setCurrentWorker', params);
  }

  getModules(userWorker: User, partnerId ) {
    let params = new HttpParams();

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    params = params.append('partnerId', partnerId);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getModules', params);
  }

  getModulesNoPartnerId(userWorker: User ) {
    let params = new HttpParams();

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getModules', params);
  }

  getModulesAnaliza(userWorker: User ) {
    let params = new HttpParams();

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    params = params.append('analytics', '1');
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getModules', params);
  }

  getProcesses(userWorker: User, moduleId, search ) {
    let params = new HttpParams();

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    if (search) {
      params = params.append('search', search);
    }
    params = params.append('moduleId', moduleId);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getProcesses', params);
  }

  getProcessesForGraphTable(userWorker: User, modules, search ) {
    let params = new HttpParams();

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    if (search) {
      params = params.append('search', search);
    }
    params = params.append('modules', JSON.stringify(modules));
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getProcesses', params);
  }

  getQuestions(userWorker: User, processId, search, helpdesk ) {
    let params = new HttpParams();

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    if (search) {
      params = params.append('search', search);
    }
    if (helpdesk) {
      params = params.append('helpdesk', helpdesk);
    }
    params = params.append('processId', processId);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getQuestions', params);
  }

  getAnswers(userWorker: User, questionId, search, helpdesk ) {
    let params = new HttpParams();

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    if (search) {
      params = params.append('search', search);
    }
    if (helpdesk) {
      params = params.append('helpdesk', helpdesk);
    }

    params = params.append('questionId', questionId);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getAnswers ', params);
  }

  updateDiary(userWorker: User, id, answerId, processId, note, moduleId, questionId) {
    let params = new HttpParams();

    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    params = params.append('id', id);

    if (answerId) {
      params = params.append('answerId', answerId);
    }

    if (processId) {
      params = params.append('processId', processId);
    }

    if (note) {
      params = params.append('note', note);
    }

    if (moduleId) {
      params = params.append('moduleId', moduleId);
    }

    if (questionId) {
      params = params.append('questionId', questionId);
    }
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/updateDiary', params);
  }

  getHelpdeskProcess(userWorker: User, id) {
    let params = new HttpParams();
    if (userWorker) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    params = params.append('id', id);
    console.log(this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdeskProcess', params);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdeskProcess', params);
  }

  setMessageReadAll(sessionUserPartner, userWorker: User, userPartner: Partner, id) {
    let params = new HttpParams();

    if (userPartner != null) {
      params = params.append('sessionUser', sessionUserPartner);
       params = params.append('partnerId', userPartner.id.toString());
    }

    if (userWorker != null) {
      params = params.append('sessionUser', userWorker.sessionUser);
      params = params.append('workerId', userWorker.workerId.toString());
    }
    params = params.append('id', id);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/setMessageReadAll', params);
  }

  setQuestion(userWorker: User, nameSmall, processId) {
    let params = new HttpParams();


    if (userWorker != null) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    params = params.append('type', 'SET');
    params = params.append('nameSmall', nameSmall);
    params = params.append('processId', processId);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/setQuestion', params);
  }

  updateQuestion(userWorker: User, id, nameSmall, processId) {
    let params = new HttpParams();

    if (userWorker != null) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    params = params.append('id', id);
    params = params.append('type', 'SET');
    params = params.append('nameSmall', nameSmall);
    params = params.append('processId', processId);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/setQuestion', params);
  }


  deleteQuestion(userWorker: User, id, nameSmall, processId) {
    let params = new HttpParams();

    if (userWorker != null) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    params = params.append('id', id);
    params = params.append('type', 'DELETE');
    params = params.append('nameSmall', nameSmall);
    params = params.append('processId', processId);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/setQuestion', params);
  }

  //ni parametra id - ker je tist samo za update
  setAnswer(userWorker: User, nameSmall, questionId) {
    let params = new HttpParams();

    if (userWorker != null) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }
    params = params.append('type', 'SET');
    params = params.append('nameSmall', nameSmall);
    params = params.append('questionId', questionId);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/setAnswer', params);
  }

  

  updateAnswer(userWorker: User, id, nameSmall, questionId) {
    let params = new HttpParams();

    if (userWorker != null) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }

    params = params.append('id', id);
    params = params.append('type', 'SET');
    params = params.append('nameSmall', nameSmall);
    params = params.append('questionId', questionId);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/setAnswer', params);
  }

  deleteAnswer(userWorker: User, id, nameSmall, questionId) {
    let params = new HttpParams();

    if (userWorker != null) {
      params = params.append('sessionUser', userWorker.sessionUser);
    }

    params = params.append('id', id);
    params = params.append('type', 'DELETE');
    params = params.append('nameSmall', nameSmall);
    params = params.append('questionId', questionId);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/setAnswer', params);
  }

  getCooperation(sessionUser) {
    let params = new HttpParams();
    params = params.append('sessionUser', sessionUser);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getCooperations ', params);
  }
  getPartners(sessionUser) {
    let params = new HttpParams();
    params = params.append('sessionUser', sessionUser);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getPartners ', params);
  }
  getWorker(sessionUser) {
    let params = new HttpParams();
    params = params.append('sessionUser', sessionUser);
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getWorkers ', params);
  }

  getCooperationHelpdesk(user: User, partner: Partner) {
    let params = new HttpParams();
    if (user) {
      params = params.append('sessionUser', user.sessionUser);
    }

    if (partner) {
      params = params.append('sessionUser', partner.sessionUser);
    }
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getCooperations ', params);
  }

  getWorkerHelpdesk(user: User, partner: Partner) {
    let params = new HttpParams();
    if (user) {
      params = params.append('sessionUser', user.sessionUser);
    }

    if (partner) {
      params = params.append('sessionUser', partner.sessionUser);
    }
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getWorkers ', params);
  }



  getHelpdeskForGraph(userWorker: User, statuses, dateFrom, dateTo, cooperations, processes) {
    let params = new HttpParams();
    params = params.append('sessionUser', userWorker.sessionUser);
    params = params.append('workerId', userWorker.workerId.toString());
    if (statuses) {
      params = params.append('statuses', JSON.stringify(statuses));
    }
    params = params.append('dateFrom', dateFrom);
    params = params.append('dateTo', dateTo);
    if (cooperations) {
      params = params.append('cooperations', JSON.stringify(cooperations));
    }
    if (processes) {
      params = params.append('processes', JSON.stringify(processes));
    }
    return this.http.post<any>( this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdesk ', params);
  }

  getAnalytics(sessionUser, helpdesk, project, statuses, cooperations,
    processes, dateFrom, dateTo) {
      let params = new HttpParams();
      params = params.append('sessionUser', sessionUser);

        params = params.append('helpdesk', helpdesk);


        params = params.append('project', project);

      if(statuses && statuses.length > 0) {
        params = params.append('statuses', JSON.stringify(statuses));
      }
      if(cooperations && cooperations.length > 0) {
        params = params.append('cooperations', JSON.stringify(cooperations));
      }
      if(processes && processes.length > 0) {
        params = params.append('processes', JSON.stringify(processes));
      }
      if(dateFrom) {
        params = params.append('dateFrom', dateFrom);
      }
      if(dateTo) {
        params = params.append('dateTo', dateTo);
      }
      return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getAnalytics', params);
  }

  /* getCustomerInfoBasic za helpdesk-tab*/
  getCustomerInfoBasic(sessionUser, contactId) {
    let params = new HttpParams();
    params = params.append('sessionUser', sessionUser);
    params = params.append('contactId', contactId);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getCustomerInfoBasic', params);
  }

  getCustomerInfo(sessionUser, contactId, period) {
    let params = new HttpParams();
    params = params.append('sessionUser', sessionUser);
    params = params.append('contactId', contactId);
    params = params.append('period', period);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getCustomerInfo', params);
  }

  getWorkers(sessionUser) {
    let params = new HttpParams();
    params = params.append('sessionUser', sessionUser);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getWorkers', params);
  }

  getHelpdeskParameters(sessionuser) {
    let params = new HttpParams();
    params = params.append('sessionUser', sessionuser);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'helpdesk/getHelpdeskParameters', params);
  }


}
